import { isNaN } from 'lodash-es';

export default function PercentageFilter() {
  return function (value, decimals) {
    if (value == null || isNaN(value)) {
      return 'N/A';
    }

    if (decimals != null) {
      return value.toFixed(decimals) + '%';
    } else {
      return value.toString(10) + '%'; // base 10
    }
  };
}
